import React from 'react'
import { NavLink } from 'react-router-dom'

export default function SidebarLink({name, link}) {
  return (
    <ul>
      <li>
        <NavLink to={link}>{name}</NavLink>
      </li>
    </ul>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/SidebarLink.js